module.exports = __webpack_public_path__ + "img/Button_Spin.013082fb.png";